import { createCommands } from '@tdp/common/commandHandler';
import { setActionPayload } from '@tdp/core';

import { IHeaderDataProvider } from './service';
import { HeaderActionTypes, headerSlice } from './slice';

export interface HeaderDataCommandHandlerDependencies {
  headerDataProvider?: IHeaderDataProvider;
}
export const createHeaderCommandHandler = ({
  headerDataProvider,
}: HeaderDataCommandHandlerDependencies) =>
  createCommands({
    name: 'headerCommands',
    handlers: {
      async *getHeaderData() {
        const getHeaderDataResponse = await headerDataProvider?.getHeaderData();
        let headerData = '{}';
        if (getHeaderDataResponse?.type === 'success') {
          headerData = getHeaderDataResponse.headerData;
          setActionPayload(HeaderActionTypes.GetShellInfo, headerData);
        }
        yield headerSlice.actions.updateShellHeaderInfo(JSON.parse(headerData));
      },
    },
  });
